import { ANTDInputStyle } from 'src/@legacy/@core/style/base/antd-input-style'
import React, { FC, useEffect, useMemo } from 'react'
import { Trans } from 'react-i18next'
import { Button } from 'src/@legacy/@core/components/share/ANTD/Button'
import { Form } from 'src/@legacy/@core/components/share/ANTD/Form'
import { Col, Row } from 'src/@legacy/@core/components/share/ANTD/Grid'
import { Input } from 'src/@legacy/@core/components/share/ANTD/Input'
import { Select } from 'src/@legacy/@core/components/share/ANTD/Select'
import { WrapperLayout } from 'src/@legacy/@core/components/share/Wrapper/WrapperLayout'
import { ContactStyle } from 'src/@legacy/@core/style/pages/page-contact.style'
import { LINK_URL_CHAT_WITH_SUPPORT } from '../../../@core/utilities/LinkURL'
import { ENUM_CATEGORIES_CONTACT_REQUESTS } from '../enum/enum'
import ContactBG from '../img/bg.png'
import FooterBG from '../img/bg-footer.png'
import { TRACKING_ID_EMPLOYEER_CONTACT_SUBMMIT } from 'src/@legacy/@core/utilities/TrackingIDConstant'
import { TextAreaProps } from 'antd/lib/input/TextArea'
const CountTextArea: FC<TextAreaProps & { maxLength: number }> = (props) => {
  const { maxLength, ...rest } = props
  return (
    <div>
      <Input.TextArea {...rest} />
      <div style={{ textAlign: 'right', color: '#7a7c82' }}>
        {rest.value?.toString().length || 0} / {maxLength}
      </div>
    </div>
  )
}
const ContactComponent: FC<{
  translate: any
  onFinish: any
  form: any
  profile: any
  currentCompany: any
  loading: any
  count: any
  currentLanguage: any
}> = (props) => {
  const { translate, currentLanguage, onFinish, form, profile, currentCompany, loading, count } = props
  const initForm = useMemo(
    () => ({
      full_name: profile?.full_name,
      phone_number: profile?.phone_number,
      email: profile?.email,
      company_name: currentCompany?.name,
      category: undefined
    }),
    [profile, currentCompany]
  )
  useEffect(() => {
    form.resetFields()
  }, [initForm])
  return (
    <>
      <style jsx global>
        {ContactStyle}
      </style>
      <style jsx global>
        {ANTDInputStyle}
      </style>
      <div className="contact-page">
        <div className="contact-wrapper" style={{ height: 965, backgroundImage: `url(${ContactBG.src})` }}>
          <WrapperLayout className="wrapper-container">
            <Row align="middle" justify="center">
              <Col xs={24}>
                <p className="title">{translate('page_employer_contact:contact_title')}</p>
                <p className="sub-title mb-0">{translate('page_employer_contact:contact_sub_title')}</p>
                <p className="sub-title mb-0">
                  <Trans i18nKey="page_employer_contact:contact_form_title">
                    <span className="high-light" />
                  </Trans>
                </p>
              </Col>
            </Row>
            <Row align="middle" justify="center">
              <Col md={24} lg={24} style={{ position: 'relative' }}>
                <div className="contact-form md:left-[310px]-mtop[116px]" style={{ position: 'relative' }}>
                  <Form name="contact-form" onFinish={onFinish} layout="vertical" form={form} initialValues={initForm}>
                    <Row gutter={[24, 0]}>
                      <Col xs={24} md={12}>
                        <Form.Item
                          label={translate('label:full_name')}
                          name="full_name"
                          rules={[
                            {
                              required: true,
                              message: translate('form:validate_required')
                            },
                            {
                              min: 5,
                              message: translate('form:validate_range_length', {
                                min: 5,
                                max: 100
                              })
                            },
                            {
                              max: 100,
                              message: translate('form:validate_range_length', {
                                min: 5,
                                max: 100
                              })
                            }
                          ]}>
                          <Input name="full_name" placeholder={translate('label:enter_your_full_name')} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={12}>
                        <Form.Item
                          label={translate('label:phone_number')}
                          name="phone_number"
                          rules={[
                            { required: true, message: translate('form:validate_required') },
                            {
                              min: 9,
                              message: translate('form:validate_range_length', {
                                min: 9,
                                max: 15
                              })
                            },
                            {
                              max: 15,
                              message: translate('form:validate_range_length', {
                                min: 9,
                                max: 15
                              })
                            },
                            { pattern: /^[0-9]*$/, message: translate('form:validate_phone_format') }
                          ]}>
                          <Input name="phone_number" placeholder={translate('label:enter_your_phone_number')} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={12}>
                        <Form.Item
                          label={translate('page_register:email_address')}
                          name="email"
                          rules={[
                            { required: true, message: translate('form:validate_required') },
                            { max: 250, message: translate('form:validate_max_length', { number: 250 }) },
                            {
                              type: 'email',
                              message: translate('form:validate_email_format')
                            }
                          ]}>
                          <Input name="email" placeholder={translate('label:enter_your_email')} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={12}>
                        <Form.Item
                          label={translate('label:company')}
                          name="company_name"
                          rules={[{ required: true, message: translate('form:validate_required') }]}>
                          <Input name="company_name" placeholder={translate('label:enter_your_company')} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={24}>
                        <Form.Item
                          label={translate('label:support_title')}
                          name="category"
                          rules={[{ required: true, message: translate('form:validate_required') }]}>
                          <Select name="category" size="large" placeholder={currentLanguage === 'en' ? 'Select topics' : 'Chọn mục hỗ trợ'}>
                            {ENUM_CATEGORIES_CONTACT_REQUESTS.map((category_contact) => (
                              <Select.Option key={category_contact.value} value={category_contact.value}>
                                {currentLanguage === 'en' ? category_contact.name_en : category_contact.name_vi}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span="24">
                        <Form.Item
                          label={translate('page_employer_contact:how_can_we_support')}
                          name="request"
                          rules={[
                            { required: true, message: translate('form:validate_required') },
                            {
                              min: 20,
                              message: translate('form:validate_range_length', {
                                min: 20,
                                max: 200
                              })
                            },
                            {
                              max: 200,
                              message: translate('form:validate_range_length', {
                                min: 20,
                                max: 200
                              })
                            }
                          ]}>
                          <CountTextArea
                            name="request"
                            maxLength={200}
                            rows={4}
                            placeholder={translate('page_employer_contact:contact_form_description')}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row align="middle" justify="center">
                      <Col xs={24} md={24}>
                        <div className="d-flex" style={{ justifyContent: 'end' }}>
                          <Button
                            style={{ padding: '12px 32px' }}
                            id={TRACKING_ID_EMPLOYEER_CONTACT_SUBMMIT}
                            disabled={loading}
                            type="primary"
                            htmlType="submit"
                            className="btn-submit"
                            size="large"
                            loading={loading}>
                            {count > 0 && <span className="mr-1">{count}</span>}
                            {translate('page_employer_contact:get_advisory')}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </Col>
            </Row>
          </WrapperLayout>
        </div>
        <div className="footer_contact footer-background" style={{ color: 'white', backgroundImage: `url(${FooterBG.src})` }}>
          <div className="mb-2 footer-text">
            <Trans i18nKey="page_employer_contact:footer_contact_form">
              <a href={LINK_URL_CHAT_WITH_SUPPORT} target="_blank" rel="noopener noreferrer" />
            </Trans>
          </div>
          <div style={{ marginTop: 16 }}>
            <a className="chat-with-support-btn" href={LINK_URL_CHAT_WITH_SUPPORT} target="_blank" rel="noopener noreferrer">
              <Trans i18nKey="page_employer_contact:chat_with_support" />
            </a>
          </div>
        </div>
      </div>
    </>
  )
}

export default ContactComponent
